import { atom } from 'recoil';

export const userAtom = atom({
  key: 'userState', // unique ID (with respect to other atoms/selectors)
  default: {
    // default value (aka initial value)
    id: null,
    profile_picture: null,
    name: null,
    email: null,
    role: null
    // beneficiaries: []
  }
});
